const colorsBlue = [
    "#E6F3F8", "#CDE7F0", "#9BCFE2", "#68B7D3", "#369FC5", "#0487B6",
    "#036C92", "#02516D", "#023649"
];
const colorsOrange = [
    "#FFDECC", "#FFB890", "#FF9960", "#FF7B30", "#FF5C00", "#CF4B00",
    "#9F3A00", "#6F2800", "#3F1700"
];

const colorsGreen = [
    "#D6F4E3", "#C4E9D4", "#8FC8A8", "#6CB38B", "#489D6D", "#258750",
    "#1E6C40", "#165130", "#0F3620"
];

const colorsRed = [
    "#FAE7E9", "#F6D4D8", "#F3C0C8", "#EFADB7", "#E78795", "#E06074",
    "#FFCB05", "#B43044", "#902636"
];


const colorsTags = [
    "#3B86FF", "#A6CF2E", "#FF6200", "#FF8A66",
    "#001FBD", "#00470E", "#FFAB4A", "#FF30DD",
    "#C94A30", "#662100", "#FFBA00", "#FF9C00",
    "#0131FF", "#008717", "#D16E17", "#FF78F2",
       
    "#000066", "#0A3B00", "#F08F30", "#800054",
    
    "#106FF4", "#45BF00", "#FF7D00", "#FE3386",
    
];

const formatos = [
    { id: '59', value: 'E-mail MKT SF' },
    { id: '60', value: 'E-mail MKT Figmails' },
    { id: '61', value: 'PCM/lauda/Roteiro/Conteúdo Blog' },
    { id: '97', value: 'Push texto/SMS/Texto curto' },
    { id: '62', value: 'Warning/Parallax/ Vitrines/Push imagem/Inapp' },
    { id: '63', value: 'Banner digital' },
    { id: '64', value: 'Peças de Whatsapp' },
    { id: '69', value: 'Peças de social' },
    { id: '67', value: 'Lâmina/PDF/PPT/Manua' },
    { id: '68', value: 'Vídeos' },
    { id: '70', value: 'LP/site/módulos site' },
    { id: '98', value: 'Footer/módulos e-mail' },
    { id: '99', value: 'Naming' },
    { id: '100', value: 'Banco de imagens' },
    { id: '101', value: 'Imagens geradas com IA' },
    { id: '65', value: 'KV/Selo/Logo' },
    { id: '103', value: 'SL (Report/Relatório/Disaster Check)' },
    { id: '104', value: 'Planejamento' },
    { id: '105', value: 'Canais presenciais polos Itaú' },
    { id: '106', value: 'Outros (peças físicas)' },
    { id: '148', value: 'Outros (peças digitais)' }
];

const versionamentos = [
    { id: 1, value: 1 },
    { id: 2, value: 2 },
    { id: 3, value: 3 },
    { id: 4, value: 4 },
    { id: 5, value: 5 },
    { id: 6, value: 6 },
    { id: 7, value: 7 },
    { id: 8, value: 8 },
    { id: 9, value: 9 },
    { id: 10, value: 10 },
    { id: 11, value: 11 },
    { id: 12, value: 12 },
    { id: 13, value: 13 },
    { id: 14, value: 14 },
    { id: 15, value: 15 }
];

const status = [
    { id: '1', value: 'Em criação ihouse', name: 'Em criação ihouse'},
    { id: '2', value: 'Em aprovação mkt/negócio', name: 'Em aprovação mkt/negócio'},
    { id: '3', value: 'Em backlog', name: 'Em backlog'},
    { id: '4', value: 'Concluído', name: 'Concluído'},
    { id: '5', value: 'Aguardando infos itaú', name: 'Aguardando infos itaú'},
    { id: '6', value: 'Aguardando infos squad', name: 'Aguardando infos squad'},
    { id: '7', value: 'Aguardando infos HUB', name: 'Aguardando infos HUB'},
    { id: '8', value: 'Planejamento', name: 'Planejamento'},
    { id: '9', value: 'Pautar', name: 'Pautar'},
    { id: '10', value: 'Cancelado', name: 'Cancelado'},
    { id: '11', value: 'Stand by', name: 'Stand by'},
    { id: '12', value: 'Em produção/hub', name: 'Em produção/hub'}
];  

const meses = [
    { id: 1, value: 'Janeiro' },
    { id: 2, value: 'Fevereiro' },
    { id: 3, value: 'Março' },
    { id: 4, value: 'Abril' },
    { id: 5, value: 'Maio' },
    { id: 6, value: 'Junho' },
    { id: 7, value: 'Julho' },
    { id: 8, value: 'Agosto' },
    { id: 9, value: 'Setembro' },
    { id: 10, value: 'Outubro' },
    { id: 11, value: 'Novembro' },
    { id: 12, value: 'Dezembro' }
]

const mesesNames = [
    { id: "01", name: 'Janeiro' },
    { id: "02", name: 'Fevereiro' },
    { id: "03", name: 'Março' },
    { id: "04", name: 'Abril' },
    { id: "05", name: 'Maio' },
    { id: "06", name: 'Junho' },
    { id: "07", name: 'Julho' },
    { id: "08", name: 'Agosto' },
    { id: "09", name: 'Setembro' },
    { id: "10", name: 'Outubro' },
    { id: "11", name: 'Novembro' },
    { id: "12", name: 'Dezembro' }
]

export {
    status, versionamentos, formatos, meses, colorsBlue, colorsGreen, colorsOrange, colorsRed, colorsTags, mesesNames
}